import { DispatcherI } from '../interfaces/dispatcher.interface'
import { DispatcherService } from '../services/dispatcher.service'
import {
    ChangeDeliveryDatePayloadT,
    ChangeOrderTakeDate,
    DispactherGetTakeOrderResponseT,
    DispatcherAutoAssignPayloadT,
    DispatcherGetCouriersReportsResponseT,
    DispatcherGetDeliveredInvoicesFileResponseT,
    DispatcherGetDeliveriesListResponseT,
    DispatcherGetOrdersWithoutAddressResponseT,
    DispatcherGetStatusesDeliveryListResponseT,
    DispatcherGetStatusesListResponseT,
    DispatcherGetTakeOrdersParamsConfigT,
    DispatcherGetTakeOrdersResponseT,
    DispatcherGetTakesListResponseT,
    DispatcherGetWaitListStatusesResponseT,
    DispatcherOrdersWithoutAddressParamsT,
    DispatcherSetOrderPayloadT,
    DispatcherSubmitCheckedOrdersPayloadT,
    DispatcherSubmitOrdersToDispatcherSectorPayloadT,
    DispatcherSubmitOrdersToSectorPayloadT,
    DispatcherSubmitOrderToCourierPayloadT,
    ListsParamsT,
} from '../types/dispatcher.types'

const dispatcherService = new DispatcherService()

class DispatcherRealisation implements DispatcherI {
    getTakeOrders(
        dispatcher_sector_id: number,
        config: DispatcherGetTakeOrdersParamsConfigT
    ): Promise<DispatcherGetTakeOrdersResponseT> {
        return dispatcherService.getTakeOrders(dispatcher_sector_id, config)
    }

    getTakeOrder(order_id: number): Promise<DispactherGetTakeOrderResponseT> {
        return dispatcherService.getTakeOrder(order_id)
    }

    getStatuses(): Promise<DispatcherGetStatusesListResponseT> {
        return dispatcherService.getStatuses()
    }

    getStatusesDelivery(): Promise<DispatcherGetStatusesDeliveryListResponseT> {
        return dispatcherService.getStatusesDelivery()
    }

    getOrdersWithoutAddress(
        params: DispatcherOrdersWithoutAddressParamsT
    ): Promise<DispatcherGetOrdersWithoutAddressResponseT> {
        return dispatcherService.getOrdersWithoutAddress(params)
    }

    setOrderAddress(sender_id: number, payload: DispatcherSetOrderPayloadT): Promise<void> {
        return dispatcherService.setOrderAddress(sender_id, payload)
    }

    submitOrdersToDispatcherSector(
        payload: DispatcherSubmitOrdersToDispatcherSectorPayloadT
    ): Promise<void> {
        return dispatcherService.submitOrdersToDispatcherSector(payload)
    }

    submitOrdersToSector(payload: DispatcherSubmitOrdersToSectorPayloadT): Promise<void> {
        return dispatcherService.submitOrdersToSector(payload)
    }

    submitOrderToCourier(payload: DispatcherSubmitOrderToCourierPayloadT): Promise<void> {
        return dispatcherService.submitOrderToCourier(payload)
    }

    submitCheckedOrders(payload: DispatcherSubmitCheckedOrdersPayloadT): Promise<void> {
        return dispatcherService.submitCheckedOrders(payload)
    }

    changeOrderTakeDate(payload: ChangeOrderTakeDate): Promise<void> {
        return dispatcherService.changeOrderTakeDate(payload)
    }

    changeOrderDeliveryDate(payload: ChangeDeliveryDatePayloadT): Promise<void> {
        return dispatcherService.changeOrderDeliveryDate(payload)
    }

    getTakesList(params: ListsParamsT): Promise<DispatcherGetTakesListResponseT> {
        return dispatcherService.getTakesList(params)
    }

    deleteTake(take_id: number): Promise<void> {
        return dispatcherService.deleteTake(take_id)
    }

    getDeliveryList(params: ListsParamsT): Promise<DispatcherGetDeliveriesListResponseT> {
        return dispatcherService.getDeliveryList(params)
    }

    deleteDelivery(delivery_id: number): Promise<void> {
        return dispatcherService.deleteDelivery(delivery_id)
    }

    getDeliveredInvoicesFile(
        fromDate: string,
        toDate: string
    ): Promise<DispatcherGetDeliveredInvoicesFileResponseT> {
        return dispatcherService.getDeliveredInvoicesFile(fromDate, toDate)
    }

    approveDelivery(delivery_id: number, payload?: FormData): Promise<void> {
        return dispatcherService.approveDelivery(delivery_id, payload)
    }

    getCouriersReports(
        dispatchers_sector_id: number
    ): Promise<DispatcherGetCouriersReportsResponseT> {
        return dispatcherService.getCouriersReports(dispatchers_sector_id)
    }

    enableAutoAssign(payload: DispatcherAutoAssignPayloadT): Promise<void> {
        return dispatcherService.enableAutoAssign(payload)
    }

    closeDelivery(deliveryId: number): Promise<void> {
        return dispatcherService.closeDelivery(deliveryId)
    }

    disableAutoAssign(payload: DispatcherAutoAssignPayloadT): Promise<void> {
        return dispatcherService.disableAutoAssign(payload)
    }

    loadWaitListStatuses(type = 1): Promise<DispatcherGetWaitListStatusesResponseT> {
        return dispatcherService.loadWaitListStatuses(type)
    }
}

export const dispatcher = new DispatcherRealisation()
